<script>
  import { onMount } from 'svelte';
  import { MDCDialog } from '@material/dialog';
  import { reparse_date } from '../../../lib/utils.js';
  import { t9n } from '../../../lib/translate.js';

  import { TS } from '../../../config/translation-keys.js';
  import { product } from 'ramda';
  import session from '../../../lib/session.js';
  import moment from 'moment';

  // component options  ------------------------------------------------------ //

  export let order;
  // internal variables ------------------------------------------------------ //

  let dialog;
  let vat;
  let total;
  let price;
  let orderer_name;

  let data = [];

  // translate --------------------------------------------------------------- //

  let button_close_label;

  // utility functions -------------------------------------------------------- //

  export const open = () => dialog.open();

  export const close = () => dialog.close();

  const get_orderer_name = order => {
    let profile = order.orderer.basic_profile;

    if (!!profile.organization_name) {
      return profile.organization_name;
    }

    return `${profile.first_name} ${profile.last_name}`;
  };

  const get_ordered_service = product_id => {
    const product = $session.merchant.products.find(
      p => p.product_id === product_id
    );

    return product.localized_names[`translation_${$session.language}`];
  };

  const init_dialog = () => {
    dialog = new MDCDialog(document.querySelector(`#receipt_id`));
    dialog.open();
    let tmp_total, tmp_vat;
    vat = order.product.orderer_vat_amount * order.details.duration;
    tmp_vat = vat;
    vat = `${vat.toFixed(2)} ${$session.merchant.currency_sign}`;
    total = order.product.orderer_price * order.details.duration;
    tmp_total = total;
    total = `${total.toFixed(2)} ${$session.merchant.currency_sign}`;
    price = tmp_total - tmp_vat;
    price = `${price.toFixed(2)} ${$session.merchant.currency_sign}`;
    orderer_name = get_orderer_name(order);

    data = [
      {
        left: t9n(TS.RECEIPT_DATE),
        right: reparse_date(
          moment
            .utc(order.details.worker_marked_as_delivered)
            .local()
            .format()
        ),
      },
      {
        left: t9n(TS.RECEIPT_ID),
        right: order.order_uuid,
      },
      {
        left: t9n(TS.RECEIPT_MERCHANT),
        right: $session.merchant.merchant_name,
      },
      {
        left: t9n(TS.RECEIPT_VAT_NUM),
        right: $session.merchant.vat_number,
      },
      {
        left: t9n(TS.RECEIPT_ORDERER),
        right: orderer_name,
      },
      {
        left: t9n(TS.RECEIPT_ORD_SERVICE),
        right: get_ordered_service(order.product.product_id),
      },
      {
        left: `${t9n(order.product.based_on)}:`,
        right: order.details.duration.toFixed(1),
      },
      {
        left: t9n(TS.RECEIPT_INIT_TIME),
        right: order.details.initial_order_time,
      },
      {
        left: t9n(TS.RECEIPT_CONF_TIME),
        right: order.details.confirmed_order_time,
      },
      {
        left: t9n(TS.PILOT_POINTS_HISTORY_PRICE_LABEL) + ':',
        right: price,
      },
      {
        left: t9n(TS.NEW_ORDER_SUM_VAT) + ':',
        right: vat,
      },
      {
        left: t9n(TS.NEW_ORDER_SUM_TOTAL) + ':',
        right: total,
      },
      {
        left: `${t9n(TS.ORDER_ACC_REF)}:`,
        right: order.details.account_reference,
      },
    ];
  };

  onMount(init_dialog);
</script>

<!--<svelte:options accessors={true}></svelte:options>-->

<div id="receipt_id" class="mdc-dialog">
  <div class="mdc-dialog__container">
    <div
      class="mdc-dialog__surface"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="my-dialog-title"
      aria-describedby="my-dialog-content">

      <!-- Title cannot contain leading whitespace due to mdc-typography-baseline-top() -->
      <h2 class="mdc-dialog__title" id="my-dialog-title">
        {t9n(TS.RECEIPT_LABEL)}
      </h2>

      <div class="mdc-dialog__content" id="my-dialog-content">

        <table class="table receipt">

          {#each data as row, i}
            <tr>
              <td class="bold-font">{row.left}</td>
              <td>
                {#if !!row.right}{row.right}{/if}

              </td>
            </tr>
          {/each}

        </table>

      </div>

      <footer class="mdc-dialog__actions">
        <buttons
          class="mdc-button mdc-button--raised"
          on:click|preventDefault|stopPropagation={close}>
          {t9n(TS.CARDS_ADD_CARD_CANCEL_LABEL)}
        </buttons>
      </footer>
    </div>
  </div>

  <div class="mdc-dialog__scrim" />
</div>

<style>
  tr {
    text-align: left;
  }

  .mdc-dialog {
    text-align: center;
  }

  .mdc-dialog__content {
    font-family: Roboto, sans-serif;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    font-size: 1rem;
    line-height: 1.5rem;
    font-weight: 400;
    letter-spacing: 0.03125em;
    text-decoration: inherit;
    text-transform: inherit;
    flex-grow: 1;
    box-sizing: border-box;
    margin: 0;
    padding: 20px 24px;
    padding-top: 20px;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }

  .mdc-dialog__title {
    font-family: Roboto, sans-serif;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    font-size: 1.25rem;
    line-height: 2rem;
    font-weight: 500;
    letter-spacing: 0.0125em;
    text-decoration: inherit;
    text-transform: inherit;
    display: block;
    position: relative;
    flex-shrink: 0;
    box-sizing: border-box;
    margin: 0;
    padding: 0 24px 9px;
    border-bottom: 1px solid transparent;
  }

  .mdc-dialog__actions {
    display: flex;
    position: relative;
    flex-shrink: 0;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    box-sizing: border-box;
    min-height: 52px;
    margin: 0;
    padding: 8px;
    border-top: 1px solid transparent;
  }

  .mdc-button {
    margin: 1em;
  }

  .btn-worker,
  btn-worker:hover {
    background-color: var(--worker-background-color);
    color: var(--orderer-foreground-color);
  }

  .btn-orderer,
  btn-orderer:hover {
    background-color: var(--orderer-background-color);
    color: var(--orderer-foreground-color);
  }

  .bold-font {
    font-weight: 1000;
    color: rgba(0, 0, 0, 0.8);
  }
</style>
